import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Server-rendered market pages (/markets/...): keep the HTML Django put in #root before React
// replaces it, so MarketDataPage can show it without a second request.
{
  const root = document.getElementById('root')
  if (root && window.location.pathname.startsWith('/markets') && root.querySelector('main')) {
    window.__SSR_ROOT__ = { url: window.location.pathname + window.location.search, html: root.innerHTML }
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 